export const CALENDLY_COST_REVIEW_URL =
  "https://calendly.com/infralyst/intro";
